<template>
	<div class="login-register-bg" :style="{height:height}">

		<div class="login-box">
			<div class="up">
				<p class="big-title">Find Password</p>
				<div class="step-list">
					<div class="step-item">
						<img class="step-image" src="../../assets/images/step1-active.png" alt="">
						<p>Send code</p>
					</div>
					<div class="separator"></div>
					<div class="step-item">
						<img class="step-image"  v-if="current_step>1" src="../../assets/images/step2-active.png" alt="">
						<img class="step-image"  v-else src="../../assets/images/step2.png" alt="">
						<p>New Password</p>
					</div>
					<div class="separator"></div>
					<div class="step-item">
						<img class="step-image" v-if="current_step>2" src="../../assets/images/step3-active.png" alt="">
						<img class="step-image" v-else src="../../assets/images/step3.png" alt="">
						<p>Success</p>
					</div>
				</div>
			</div>

			<div class="bottom">
				<div v-show="current_step===1">
					<div class="form">
						<div class="form-group">
							<div class="form-label">Email</div>
							<div class="form-control">
								<input type="text" class="input" placeholder="Enter email" v-model="form_data1.email" />
							</div>
						</div>

						<div class="form-group">
							<div class="form-label">Code</div>
							<div class="form-code">
								<input type="text" class="input" placeholder="Enter code" v-model="form_data1.code" />
								<email-code class="sms-code" scene="password"  :email="form_data1.email"></email-code>
							</div>
						</div>
						
						<div class="btn-submit" @click="finish1">nextStep</div>
						<p class="b-text"><a @click="go2login" class="btn-login">Back to Sign in</a></p>
					</div>
				</div>
				<div v-show="current_step===2">
					<div class="form">
						<div class="form-group">
							<div class="form-label">Password</div>
							<div class="form-control" style="display:flex;align-items:center">
								<input class="input" placeholder="New Password" :type="password_type" v-model="form_data2.password" />
                <div style="margin-left:10px;">
										<img @click="password_type = password_type =='text' ? 'password' :'text'"
											:src="password_type == 'text' ? require('../../assets/images/dieplay@2x.png'):require('../../assets/images/hide@2x.png')"
											style="width:20px;" :style="{height:password_type == 'text'?'13px':'9px'}" />
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="form-label">Re-enter Password</div>
							<div class="form-control" style="display:flex;align-items:center">
								<input  class="input" placeholder="Re-enter Password" :type="password_type" v-model="form_data2.confirm_password" />
                <div style="margin-left:10px;">
										<img @click="password_type = password_type =='text' ? 'password' :'text'"
											:src="password_type == 'text' ? require('../../assets/images/dieplay@2x.png'):require('../../assets/images/hide@2x.png')"
											style="width:20px;" :style="{height:password_type == 'text'?'13px':'9px'}" />
								</div>
							</div>
						</div>

						<div class="btn-submit" @click="finish2">nextStep</div>
					</div>
				</div>
				<div v-show="current_step===3">
					<div class="ok-wrap">
						<img src="../../assets/images/icon-find-success.png" alt="" class="success">
						<div class="text">
							<p class="up-text">
								Password reset successful,Please login to your account
							</p>
							<p class="bottom-text">Please remember your account password. The page is redirecting …. Or click to <a @click="go2login" class="btn-login">Login</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import EmailCode from "@/components/EmailCode.vue";
import { CheckEmail, ResetPassword } from "@/api/index.js";
import localStorage from "@/utils/localStorage.js";

export default {
  name: "FindPwd",
  components: {
    EmailCode,
  },
  data() {
    return {
      is_click: false,
      height: "600px",
      current_step: 1,
      form_data1: {
        email: "",
        code: "",
      },
      form_data2: {
        password: "",
        confirm_password: "",
      },
      password_type:'password',
    };
  },
  computed: {},
  created() {
    this.height = window.innerHeight - 78 + "px";
  },
  methods: {
    go2login() {
      this.$router.replace({ name: "Login" });
    },
   
    finish1() {
      if (!this.form_data1.code) {
        this.$layer.msg(`place enter code`);
        return;
      }
      CheckEmail({
        ...this.form_data1,
        scene: "password",
      })
        .then(() => {
          this.current_step = 2;
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    finish2() {
      if (!this.form_data2.password) {
        this.$layer.msg("Enter Password");
        return;
      }
      if (!this.form_data2.confirm_password) {
        this.$layer.msg("Re-enter Password");
        return;
      }
      if (this.form_data2.password != this.form_data2.confirm_password) {
        this.$layer.msg("Password inconsistency");
        return;
      }
      ResetPassword({
        ...this.form_data1,
        ...this.form_data2,
      })
        .then(() => {
          this.current_step = 3;
          setTimeout(() => {
            this.$router.replace({ name: "Login" });
          }, 3000);
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login-register-bg {
  background: #ffffff;
  padding-top: 100px;
  .login-box {
    width: 100%;
    height: 700px;
    margin: 0 auto;
    background: #ffffff;

    .up {
      height: 210px;
      border-bottom: 1px solid #e2e2e2;
      .big-title {
        padding: 50px 0 40px;
        font-size: 20px;
        color: #2c2e30;
        font-weight: bold;
        text-align: center;
      }

      .step-list {
        display: flex;
        justify-content: center;
        align-items: center;
        .separator {
          margin-top: -22px;
          width: 120px;
          height: 2px;
          background: #e2e2e2;
          box-sizing: border-box;
        }
        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 120px;
          .step-image {
            width: 35px;
            height: 35px;
          }
          p {
            margin-top: 8px;
          }
        }
      }
    }

    .bottom {
      .form {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 360px;
        margin: 30px auto 0;
        .form-group {
          width: 400px;
          margin-top: 20px;
          .form-label {
            font-size: 14px;
            color: #000;
          }
          .form-control {
            position: relative;
            .input {
              width: 100%;
              height: 40px;
              line-height: 40px;
              border: 1px solid #cbcbcb;
              background: #ffffff;
              border-radius: 2px;
              padding-left: 10px;
              outline: none;
              &.input-medium {
                width: 160px;
              }
            }

            .btn-code {
              position: absolute;
              top: 12px;
              right: 0;
            }
          }
          .form-code {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 40px;
            padding-right: 10px;
            border: 1px solid #cbcbcb;
            background: #ffffff;
            border-radius: 2px;
            padding-left: 5px;
            outline: none;
            .input {
              height: 35px;
              line-height: 35px;
              // background: #FFFFFF;
              border: none;
              outline: none;
              &.input-medium {
                width: 160px;
              }
            }
            .sms-code {
              margin-top: 0;
            }
          }
        }

        .btn-submit {
          margin: 50px 0 25px;
          width: 400px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #212121;
          border-radius: 2px;
          color: white;
          cursor: pointer;
        }
        .b-text {
          width: 100%;
          color: #666;
          font-size: 14px;
          text-align: center;
          .btn-login {
            color: #303234;
          }
        }
      }

      .ok-wrap {
        display: flex;
		flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 90px;
        .success {
          width: 55px;
          height: 55px;
          
        }
        .text {
          font-weight: bold;
		  margin-top: 30px;
          .up-text {
            color: #1a1a1a;
            font-size: 16px;
          }

          .bottom-text {
            margin-top: 10px;
            color: #999999;
            font-size: 12px;
            .btn-login {
              color: #fa3d5a;
            }
          }
        }
      }
    }
  }
}
</style>
